<div
  class="algorithm-list-card"
  [class.selectable]="selectable"
  [class.selected]="selectable && selected"
  [class.pending]="pending"
  [class.warn]="status === 'warn'"
  [class.err]="status === 'err'"
  (click)="toggleSelected()"
>
  <div class="accent" aria-hidden="true"></div>

  <div class="body">
    <div class="header">
      @if (selectable) {
        <fa-icon
          class="select-indicator"
          [icon]="selected ? ['fas', 'check-square'] : ['far', 'square']"
        ></fa-icon>
      }

      <fa-icon class="algo-icon" [icon]="['fas', 'microchip']"></fa-icon>

      <span class="eyebrow">{{
        "feed-algorithms.eyebrow.algorithm" | translate
      }}</span>

      <span class="header-spacer"></span>

      @if (!selectable && editable) {
        <sui-button
          class="edit-btn"
          size="sm"
          variant="ghost"
          [leadingIcon]="['fas', 'pen']"
          [iconOnly]="true"
          [disabled]="pending"
          [ariaLabel]="'feed-algorithms.button.edit' | translate"
          [suiTooltip]="'feed-algorithms.button.edit' | translate"
          (click)="onEdit(); $event.stopPropagation()"
        ></sui-button>
      }

      @if (!selectable) {
        <sui-button
          class="detach-btn"
          size="sm"
          variant="ghost"
          [leadingIcon]="['fas', 'xmark']"
          [iconOnly]="true"
          [disabled]="pending"
          [loading]="pending"
          [ariaLabel]="'feed-algorithms.button.detach' | translate"
          [suiTooltip]="'feed-algorithms.button.detach' | translate"
          (click)="onDetach(); $event.stopPropagation()"
        ></sui-button>
      }
    </div>

    <div class="title" [title]="algorithm.name">{{ algorithm.name }}</div>

    @if (hasRuntimeInfo) {
      <div class="kpis">
        <div class="kpi">
          <div class="kpi-label">
            {{ "feed-algorithms.label.last-run" | translate }}
          </div>
          <div class="kpi-value">
            <span class="status-dot" aria-hidden="true"></span>
            <span class="kpi-text">{{ lastRunRelative ?? "—" }}</span>
          </div>
        </div>

        <div class="kpi">
          <div class="kpi-label">
            {{ "feed-algorithms.label.total-runs" | translate }}
          </div>
          <div class="kpi-value count">{{ runsCount }}</div>
        </div>

        @if (runHistory.length) {
          <div class="kpi history">
            <div class="bars" aria-hidden="true">
              @for (entry of runHistory; track $index) {
                <span
                  class="bar"
                  [class.skip]="entry === 0"
                  [class.slow]="entry === 2"
                ></span>
              }
            </div>
          </div>
        }
      </div>
    }

    @if (displayParams.length) {
      <div class="params">
        @for (param of displayParams; track $index) {
          <span class="param-pill">
            @if (param.label) {
              <span class="param-key">{{ param.label }}</span>
            }
            @if (param.value) {
              <span class="param-value" [title]="param.value">{{
                param.value
              }}</span>
            }
          </span>
        }
      </div>
    }
  </div>
</div>
